import React from "react";
import IncidentMap from "./components/IncidentMap";

function App() {
  return (
    <div className="site-shell">
      <header className="site-hero">
        <h1>Sitrep Now</h1>
        <p>Real-time community incident intelligence</p>
      </header>
      <IncidentMap />
    </div>
  );
}

export default App;
